import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { QRCodeModule } from 'angularx-qrcode';
import { NgOtpInputModule } from 'ng-otp-input';
import { Routing } from './app.routing';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './components/app.component';
import { NavMenuComponent } from './components/common/navmenu.component';
import { HomeViewComponent } from './components/common/homeView.component';
import { ForbiddenViewComponent } from './components/common/forbiddenView.component';
import { SpinnerComponent } from './components/common/spinner.component';
import { AnnouncementsComponent } from './components/common/announcements.component';
import { LogoHeaderComponent } from './components/common/logoHeader.component';
import { CertificateFormComponent } from './components/certificates/certificateForm.component';
import { CertificateRenewalFormComponent } from './components/certificates/certificateRenewalForm.component';
import { LoginFormComponent } from './components/account/loginForm.component';
import { ResetPasswordFormComponent } from './components/account/resetPasswordForm.component';
import { ConfirmResetPasswordFormComponent } from './components/account/confirmResetPasswordForm.component';
import { LogoutViewComponent } from './components/account/logoutView.component';
import { AccountViewComponent } from './components/account/accountView.component';
import { ProfileViewComponent } from './components/account/profileView.component';

import { TestCertificateComponent } from './components-to-remove/testCertificate.component';
import { CultureInterceptor } from './services/common/cultureInterceptor.service';



@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeViewComponent,
        ForbiddenViewComponent,
        CertificateFormComponent,
        CertificateRenewalFormComponent,
        TestCertificateComponent,
        SpinnerComponent,
        AnnouncementsComponent,
        LogoHeaderComponent,
        LoginFormComponent,
        LogoutViewComponent,
        AccountViewComponent,
        ProfileViewComponent,
        ResetPasswordFormComponent,
        ConfirmResetPasswordFormComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        Routing,
        QRCodeModule,
        NgOtpInputModule,
        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot(), // ToastrModule added
        ],
    providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: CultureInterceptor,
        multi: true,
    }],
})
export class AppModuleShared {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/app.shared.module.ts